<template>
    <div>
        <AlertModal :controller="controller.alertModal"></AlertModal>
        <ConfirmModal :controller="controller.confirmModal"></ConfirmModal>
        <LoadingModal :controller="controller.loadingModal"></LoadingModal>
        <ConfirmRedeemModal :controller="controller.confirmRedeemModal"></ConfirmRedeemModal>
        <SerialModal :controller="controller.serialModal"></SerialModal>
        <DrawDeliveryModal :controller="controller.drawDeliveryModal"></DrawDeliveryModal>
        <ShippingAddressModal :controller="controller.shippingAddressModal"></ShippingAddressModal>
        <AddAddressModal :controller="controller.addAddressModal"></AddAddressModal>
        <EditAddressModal :controller="controller.editAddressModal"></EditAddressModal>
        <ListAddressModal :controller="controller.listAddressModal"></ListAddressModal>
        <AddTaxAddressModal :controller="controller.addTaxAddressModal"></AddTaxAddressModal>
        <EditTaxAddressModal :controller="controller.editTaxAddressModal"></EditTaxAddressModal>
        <ListTaxAddressModal :controller="controller.listTaxAddressModal"></ListTaxAddressModal>
        <OtpModal :controller="controller.otpModal"></OtpModal>
        <RegisterSuccessModal :controller="controller.registerSuccessModal"></RegisterSuccessModal>
        <MarketingOptionModal :controller="controller.marketingOptionModal"></MarketingOptionModal>
        <AlertNonButtonModal :controller="controller.alertNonBtnModal" />
        <PdpaModal :controller="controller.pdpaModal" />
        <AppointmentSuccessModal :controller="controller.appointmentSuccessModal" />
        <ClaimAlertModal :controller="controller.claimAlertModal" />
        <RedLicensePlateModal :controller="controller.redLicensePlateModal" />
    </div>
</template>
<script>
//generic
import AlertModal from './Generic/AlertModal/AlertModal.vue';
import ConfirmModal from "./Generic/ConfirmModal/ConfirmModal.vue";
import LoadingModal from './Generic/LoadingModal/LoadingModal.vue';
//redeem
import ConfirmRedeemModal from '@/module/Detail/modal/ConfirmRedeemModal/ConfirmRedeemModal.vue';
import SerialModal from '@/module/Detail/modal/SerialModal/SerialModal.vue';
import DrawDeliveryModal from '@/module/Detail/modal/DrawDeliveryModal/DrawDeliveryModal.vue';
import ShippingAddressModal from '@/module/Detail/modal/ShippingAddressModal/ShippingAddressModal.vue';
//address
import AddAddressModal from '@/module/Address/DeliveryAddress/modal/AddAddressModal/AddAddressModal.vue';
import EditAddressModal from '@/module/Address/DeliveryAddress/modal/EditAddressModal/EditAddressModal.vue';
import ListAddressModal from '@/module/Address/DeliveryAddress/modal/ListAddressModal/ListAddressModal.vue';
import AddTaxAddressModal from '@/module/Address/TaxAddress/modal/AddTaxAddressModal/AddTaxAddressModal.vue';
import EditTaxAddressModal from '@/module/Address/TaxAddress/modal/EditTaxAddressModal/EditTaxAddressModal.vue';
import ListTaxAddressModal from '@/module/Address/TaxAddress/modal/ListTaxAddressModal/ListTaxAddressModal.vue';
//Other core modal
import OtpModal from './Otp/OtpModal.vue';
import RegisterSuccessModal from '@/module/Register/modal/RegisterSuccessModal/RegisterSuccessModal.vue';
import MarketingOptionModal from './Terms/MarketingOptionModal/MarketingOptionModal.vue';
import AlertNonButtonModal from './Generic/AlertNonButtonModal/AlertNonButtonModal.vue';
import PdpaModal from './Authen/PdpaModal/PdpaModal.vue';
import AppointmentSuccessModal from '@/module/Appointment/modal/AppointmentSuccessModal/AppointmentSuccessModal.vue';
import ClaimAlertModal from '@/module/Appointment/modal/ClaimAlert/ClaimAlertModal.vue';
import RedLicensePlateModal from '@/module/Appointment/modal/RedLicensePlateModal/RedLicensePlateModal.vue';

export default {
    name: 'ModalMaster',
    components: {
        AlertModal,
        ConfirmModal,
        LoadingModal,
        ConfirmRedeemModal,
        SerialModal,
        ShippingAddressModal,
        DrawDeliveryModal,
        AddAddressModal,
        EditAddressModal,
        ListAddressModal,
        AddTaxAddressModal,
        EditTaxAddressModal,
        ListTaxAddressModal,
        OtpModal,
        RegisterSuccessModal,
        MarketingOptionModal,
        AlertNonButtonModal,
        PdpaModal,
        AppointmentSuccessModal,
        ClaimAlertModal,
        RedLicensePlateModal
    },
    props: {
        controller: {
            type: Object,
            required: true,
        },
    },
}
</script>
